import { useCachedRequest } from "@/shared/hooks/use-cached-request";

type GlobalStats = {
  totalRequestsCounter: number;
};

export function useGlobalStats() {
  return useCachedRequest<GlobalStats>({
    url: "/global_stats",
    swrOptions: {
      keepPreviousData: true,
      revalidateOnFocus: true,
      refreshInterval: 60000,
      revalidateIfStale: true,
      revalidateOnReconnect: true,
    },
    anonymousRequest: true,
  });
}
